import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownList,
  Input
} from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';
import useInventoryStockContext from 'contexts/inventory-stock.context/context';
import { MAIN_STORE_ROUTE_KEYS, weightMeasurement } from 'utils/constants';
import './styles.scss';

const KitchenInventoryStockBulkEdit = () => {
  const navigate = useNavigate();
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const { stocksToEdit } = useInventoryStockContext();

  const [measurement, setMeasurement] = useState(weightMeasurement[0].name);
  const [allDamaged, setAllDamaged] = useState(false);

  useEffect(() => {
    if (!stocksToEdit) {
      navigate(`${MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK_BULK_EDIT}`);
    }
  }, [stocksToEdit, navigate]);

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to stock');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  return (
    <div className='ml-2 md:ml-8 edit-stock'>
      <h4 className='text-[24px] font-semibold text-[#2E3031] mb-11'>Edit Selected Items</h4>
      <div className='bg-[#F7F7F8] w-full max-w-[678px] h-auto p-1 flex  justify-center items-center'>
        <div className='bg-white w-full maxw-[670px] h-auto rounded-md  pt-6'>
          <h4 className='font-semibold text-[20px] pl-7 mb-1'>Update Selected Items</h4>
          <p className='text-[#6F7376] text-sm mb-8 pl-7'>Did any part of this item get damaged?</p>
          {stocksToEdit &&
            stocksToEdit.map((stock) => (
              <div key={stock.id} className='px-7 pb-6 form'>
                <div className='flex justify-between gap-6 flex-wrap mb-6'>
                  <div key={stock.id} className='w-full md:w-[340px] relative'>
                    <Input
                      type='text'
                      label='Item'
                      name='name'
                      value={stock?.ingredient?.name}
                      disabled
                      className='w-full'
                      placeholder='Carb rice and spices'
                      inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px]'
                    />
                    <div className='w-[70px] absolute truncate py-1 px-2 z-10 rounded-[100px] shadow bottom-[15%] right-[5%] font-bold text-sm text-center bg-white'>
                      {Number(stock.quantity)} units
                    </div>
                  </div>
                  <div className='w-full md:w-[250px] flex gap-2 relative'>
                    <Input
                      type='tel'
                      label='Qty damaged'
                      name='quantity'
                      className='w-full'
                      placeholder='550'
                      inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px]'
                    />
                    <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
                      <Dropdown
                        content={
                          <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                            <span className='text-[#6F7376] truncate'>{measurement}</span>
                            <ArrowDownIcon className='w-5 h-5 text-[#96999C]' />
                          </div>
                        }>
                        <DropdownList>
                          {weightMeasurement.map((stock) => (
                            <DropdownItem
                              key={stock.value}
                              onClick={() => {
                                setMeasurement(stock.name);
                              }}>
                              {stock.name}
                            </DropdownItem>
                          ))}
                        </DropdownList>
                      </Dropdown>
                    </div>
                  </div>
                  <div className='w-full'>
                    <Input
                      type='checkbox'
                      className='mr-1'
                      checked={allDamaged}
                      onChange={() => {
                        setAllDamaged(!allDamaged);
                      }}
                      label='Mark all as damaged'
                    />
                  </div>
                  <div className='w-full'>
                    <Input
                      type='text'
                      label='Add a note'
                      placeholder='Why is the item damaged'
                      name='note'
                      className='w-full'
                      inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[94px]'
                    />
                  </div>
                </div>
              </div>
            ))}
          <div className='flex justify-end gap-6 py-7 px-4 md:px-7 items-center border-t-2 border-t-[#F7F7F8]'>
            <p className='text-sm font-medium'>Cancel</p>
            <Button variant='block' color='primary' small className='w-[153px]'>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitchenInventoryStockBulkEdit;
